<template>
    <div style="width: 135px;display: inline-block;">
        <template v-if="!chkMobileAt">
            <datepicker style="width:100px; float: left;"
                        ref="datepicker"
                        v-if="setAt"
                        :value="date"
                        :minimum-view="type"
                        :maximum-view="maximumView"
                        :language="language"
                        :format="format"
                        :disabled-dates="disabledDates"
                        @selected="selDate">
            </datepicker>
        </template>
        <template v-if="chkMobileAt">
            <div v-show="openAt"
                 style="position: fixed;z-index: 10;width: 100%;height: 100%;top: 0;left: 0;"
                 @click="closePicker()">
                <div style="position: fixed;z-index: 10;width: 100%;height: 100%;background: #ddd;opacity: 0.5"></div>
                <div style="width: 100%;position: fixed;height: 100%;top: 50%;left: 50%;margin-left: -150px;margin-top: -180px;z-index: 11;"
                     @click="pickerClick($event)">
                    <datepicker style="width: 100px;"
                                ref="datepicker"
                                v-if="setAt"
                                :value="date"
                                :minimum-view="type"
                                :maximum-view="maximumView"
                                :language="language"
                                :format="format"
                                :disabled-dates="disabledDates"
                                @selected="selDate">
                    </datepicker>
                </div>
            </div>
            <input type="text"
                   readonly="readonly"
                   class="app_input"
                   style="float: left;width: 105px;"
                   v-model="cusInputDate"
                   @click="openPicker()">
        </template>
        <button class="mgt5 mgl5"
                @click="openPicker()">
            <div class="img-com" :class="btnClass"><span>달력 아이콘</span></div>
        </button>
    </div>
</template>

<script>
    /*
    * - 사용 방법
    *
    *  1. 일선택 :
    *       <vue-datepicker :type="'day'"
    *                       :sel-callback-func='selCallbackFunc'
    *                       :nrtr-year="'2019'"
    *                       :set-date="'20190909'"></vue-datepicker>
    *  2. 월선택 :
    *       <vue-datepicker :type="'month'"
    *                       :sel-callback-func='selCallbackFunc'
    *                       :nrtr-year="'2019'"
    *                       :set-date="'201909'"></vue-datepicker>
    * - props 정의
    *
    *  1. type :
    *    - 필수로 넘겨야 할 값
    *    - 'month' 월선택,'day' 일선택
    *
    *  2. sel-callback-func :
    *    - 필수 아님
    *    - 월 또는 일선택 후 호출할 함수 return 값은 선택한 년월 또는 년월일
    *    - return 값 format은 yyyymmdd (예:'20190909','201909')
    *
    *  3. nrtr-year :
    *    - 필수 아님
    *    - 보육년도를 넘길시 해당 보육년도에 해당하는 일 또는 월 외에는 disabled 되어 선택 불가능
    *    - 값이 없을시 모든 월 또는 일자를 선택 할 수 있다.
    *
    *  4. set-date :
    *    - 필수아님
    *    - mounted 시 세팅될 최초값. 없을 시 현재 월 또는 일자로 기본 세팅 됩니다.(예: '20190909','201909')
    *
    *  5. params :
    *    - 필수아님
    *    - 있는 경우 callback에 넣어서 보내준다.
    * */
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
    import ko from "vuejs-datepicker/dist/locale/translations/ko";


    export default {
        name: "vue-datepicker",
        components: {
            Datepicker
        },
        props:['type','selCallbackFunc','nrtrYear','setDate','mobileAt','setBtnClass', 'params'],
        data: function(){
            return {
                setAt:false,
                date: new Date(),
                language:ko,
                format: null,
                disabledDates: {},
                maximumView:'month',
                cusInputDate:'',
                openAt:false,
                chkMobileAt:false,
                btnClass: '_bt-ic08'
            }
        },
        methods: {
            init: function(){
                if(typeof this.mobileAt == 'undefined'||this.mobileAt == null){
                    this.chkMobileAt = false;
                }else{
                    this.chkMobileAt = this.mobileAt;
                }

                if(typeof this.type == 'undefined'|| this.type == null){
                    this.type = 'day';
                }

                if(typeof this.setBtnClass != 'undefined'&& this.setBtnClass != null){
                    this.btnClass = this.setBtnClass;
                }

                if(this.type == 'day'){
                    this.format = 'yyyy-MM-dd';
                }else if(this.type == 'month'){
                    this.format = 'yyyy-MM';
                }

                if(typeof this.nrtrYear == 'undefined'||this.nrtrYear == null){
                    this.maximumView = 'year';
                }

                this.initDate();

                this.disabledDates['customPredictor'] = this.customPredictor;

                this.$nextTick(function(){
                    this.setAt = true;
                });
            },
            getDateStr: function(date){
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                if(String(month).length == 1) month = '0'+month;
                let day = date.getDate();
                if(String(day).length == 1) day = '0'+day;

                let setDate = '';

                if(this.type == 'day'){
                    setDate = year + '' + month + '' + day;
                }else{
                    setDate = year + '' + month;
                }

                return setDate;
            },
            selDate: function(date){
                var setDate = this.getDateStr(date);

                if(typeof this.selCallbackFunc != 'undefined'&& this.selCallbackFunc != null){
                    const errAt = this.selCallbackFunc(setDate, this.params);

                    if(errAt){
                        this.initDate();
                    }else{
                        if(this.type == 'day'){
                            this.cusInputDate =
                                setDate.substring(0,4) + '-' +
                                setDate.substring(4,6) + '-' +
                                setDate.substring(6,8);
                        }else if(this.type == 'month'){
                            this.cusInputDate =
                                setDate.substring(0,4) + '-' +
                                setDate.substring(4,6) ;
                        }


                    }
                }else{
                    if(this.type == 'day'){
                        this.cusInputDate =
                            setDate.substring(0,4) + '-' +
                            setDate.substring(4,6) + '-' +
                            setDate.substring(6,8);
                    }else if(this.type == 'month'){
                        this.cusInputDate =
                            setDate.substring(0,4) + '-' +
                            setDate.substring(4,6) ;
                    }
                }

                this.openAt = false;
            },
            initDate: function(){
                let dayInfo = this.$store.getters.getDayInfo;

                this.$nextTick(function(){
                    if(typeof this.setDate == 'undefined' || this.setDate == null || this.setDate==""){
                        this.date = new Date(
                            Number(dayInfo.yy),
                            Number(dayInfo.mm) - 1,
                            Number(dayInfo.dd)
                        );
                        if(this.type == 'day'){
                            this.cusInputDate =
                                dayInfo.yy + '-' +
                                dayInfo.mm + '-' +
                                dayInfo.dd;

                            this.selCallbackFunc(dayInfo.ymd, this.params);
                        }else if(this.type == 'month'){
                            this.cusInputDate =
                                dayInfo.yy + '-' +
                                dayInfo.mm;
                            this.selCallbackFunc(dayInfo.yy+dayInfo.mm, this.params);
                        }

                    }else{
                        let day = '01';

                        if(this.type == 'day') day = this.setDate.substring(6,8);

                        this.date = new Date(
                            Number(this.setDate.substring(0,4)),
                            Number(this.setDate.substring(4,6)) - 1,
                            Number(day)
                        );

                        if(this.type == 'day') {
                            this.cusInputDate =
                                this.setDate.substring(0, 4) + '-' +
                                this.setDate.substring(4, 6) + '-' +
                                day;
                        }else if(this.type == 'month'){
                            this.cusInputDate =
                                this.setDate.substring(0, 4) + '-' +
                                this.setDate.substring(4, 6);
                        }
                    }
                });

            },
            openPicker: function() {
                this.$refs.datepicker.showCalendar();
                this.$refs.datepicker.$el.getElementsByTagName('input')[0].focus();
                this.openAt = true;
            },
            closePicker: function(){
                this.$refs.datepicker.close();
                this.openAt = false;
            },
            customPredictor: function(date) {

                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                if(String(month).length == 1) month = '0'+month;
                var ym = year + '' + month;
                if(typeof this.nrtrYear != 'undefined'&& this.nrtrYear != null){
                    const fromYear = this.nrtrYear;
                    const toYear = Number(this.nrtrYear) + 1;

                    if(ym >= fromYear + '03'&&ym <= toYear + '02'){
                        return false;
                    }else{
                        return true;
                    }
                }else{
                    return false;
                }

            },
            pickerClick: function(event){
                event.stopPropagation();
            }
        },
        mounted: function(){
            this.init();
        }
    }
</script>

<style type="text/css">
    .vdp-datepicker input[type="text"]{
        width: 100px;
    }

    .vdp-datepicker .vdp-datepicker__calendar{
        width: 200px;
        /*position: fixed;*/
    }

    .vdp-datepicker .vdp-datepicker__calendar .day-header:nth-child(1){
        color: #ff7367;
    }

    .vdp-datepicker .vdp-datepicker__calendar .day-header:nth-child(7){
        color: #1780ba;
    }

    .vdp-datepicker .vdp-datepicker__calendar .day{
        height: 25px;
        line-height: 25px;
        font-size: 13px;
    }

    .vdp-datepicker .vdp-datepicker__calendar .day-header{
        border-bottom: 1px solid #e0e0e0;
        font-size: 14px;
    }

    .vdp-datepicker .vdp-datepicker__calendar .cell.selected{
        background: #007fff;
        color: #ffffff;
    }
</style>